<script setup>

import { Graph, Label, Point } from '@ksassnowski/vueclid'
import { ref, watch } from 'vue'

const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
    value: {
        type: Number,
        required: false,
    }
});

const p0 = ref(props.data.p0);

watch(
    () => props.value, () => {
    p0.value = props.value;
})
</script>

<template>
    <div class="line-graph">
        <Graph
            :origin="[-data.domainX[0], 10]"
            :height="500"
            :width="500"
            :grid="false"
            :domain-x="data.domainX"
            :domain-y="[-5, 15]"
            :grid-size="data.gridSize"
        >
            <template v-if="p0 !== null">
                <Label :position="[p0, 1]" text="A" size="small"/>
                <Point
                    :position="[p0, 0]"
                    color="indigo"
                />
            </template>

            <template v-if="data.p1 !== null">
                <Label :position="[data.p1, 1]" text="B" size="small"/>
                <Point
                    :position="[data.p1, 0]"
                    color="red"
                />
            </template>
            <template v-if="data.p2 !== null">
                <Label :position="[data.p2, 1]" text="C" size="small"/>
                <Point
                    :position="[data.p2, 0]"
                    color="blue"
                />
            </template>
            <template v-if="data.p3 !== null">
                <Point
                    :position="[data.p3, 0]"
                    color="black"
                />
                <Label :position="[data.p3, 1]" text="D" size="small"/>
            </template>
        </Graph>
        <!--        <input type="number" name="dot" id="dot" v-model="x" step="0.1" min="-5" max="5">-->
        <!--        <input type="range" name="dot" id="dot" v-model="x" step="0.1" min="-10" max="10">-->
    </div>
</template>

<style>
.line-graph text[x="236"] {
    display: none !important;
}

.line-graph line[x1="250"] {
    display: none !important;
}

</style>
